// Function to format bytes into bigger increments
export var formatBytes = function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var byte = 1024;
  var exp = Math.floor(Math.log(bytes) / Math.log(byte));
  return parseFloat((bytes / Math.pow(byte, exp)).toFixed(decimals)) + "".concat(['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'][exp], "B");
};